<template>
  <div class="order-card">
    <div class="px-4 py-4 flex justify-between items-center gap-6 shadow-border-b mdmax:px-4 mdmax:py-4">
      <div class="flex gap-3 mdmax:items-start mdmax:gap-1 mdmax:flex-col justify-between items-center">
        <span>
          <span class="inline-flex px-2 py-1 text-xs rounded-md mdmax:flex-shrink-0 text-center" :style="'backgroundColor: ' + data.status_color + '; color: white;'">{{ data.status_display }}</span>
        </span>
        <div>
          <span class="text-neutral-700 font-medium mdmax:text-sm block text-xs mb-1">{{ data.created_time_display }}</span>
          <span class="text-neutral-500 mdmax:text-sm block text-xs mb-1"> <span class="text-neutral-700 font-medium">{{ $t('order.orderCard.orderNumber') }}:</span> {{ data.order_id }} </span>
          <p class="text-neutral-500 text-xs flex items-center gap-2 mdmax:flex-col mdmax:gap-1 mdmax:items-start">
            <span> <span class="text-neutral-700 font-medium">AWB Linknau:</span> {{ data.awb }} </span>
            <template v-if="data.external_awb">
              <span class="mdmax:hidden">|</span>
              <span> <span class="text-neutral-700 font-medium">{{ $t('order.orderCard.awbPartner') }}:</span> {{ data.external_awb }} </span>
            </template>
          </p>
        </div>
        <div class="flex items-center gap-6" v-if="isMobile">
          <img :src="data.delivery_service_logo" class="max-h-14" v-if="data.delivery_service_logo" />
          <LogisticPlaceholder :logisticName="data.delivery_service_name" v-else />
          <span class="text-xs text-secondary-500 bg-secondary-200 py-1 px-2 rounded-md" v-if="data.delivery_service_name">{{ data.delivery_service_name }}</span>
          <Button :buttonText="$t('order.orderCard.moreDetail')" type="secondary" @action="goToDetail(data.order_id)" v-if="!isMobile" />
        </div>
      </div>

      <span v-if="isMobile" class="inline-block cursor-pointer" @click="expand()">
        <Chevron direction="down" />
      </span>
      <div class="flex items-center gap-6" v-if="!isMobile">
        <img :src="data.delivery_service_logo" class="max-h-14" v-if="data.delivery_service_logo" />
        <LogisticPlaceholder :logisticName="data.delivery_service_name" v-else />
        <span class="text-xs text-secondary-500 bg-secondary-200 py-1 px-2 rounded-md text-center" v-if="data.delivery_service_name">{{ data.delivery_service_name }}</span>
        <Button :buttonText="$t('order.orderCard.moreDetail')" type="secondary" @action="goToDetail(data.order_id)" v-if="!isMobile" />
      </div>
    </div>

    <div class="flex justify-between items-start shadow-border-b text-neutral-500 mdmax:flex-col mdmax:shadow-none" :class="{ hidden: !visibleContent && isMobile }">
      <div class="w-2/5 border-r p-4 mdmax:w-full mdmax:p-4 mdmax:border-none mdmax:shadow-border-b">
        <div class="py-2 mb-2" v-if="isMobile">
          <Button buttonText="Lebih Rinci" type="secondary" size="full" @action="goToDetail(data.order_id)" />
        </div>
        <div class="flex justify-between items-start gap-6 mdmax:gap-2">
          <div class="w-2/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.senderName') }}</p>
            <p class="font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden" :title="data.sender_name">{{ data.sender_name }}</p>
            <p class="text-neutral-400 text-sm">{{ data.sender_phoneno }}</p>
          </div>
          <div class="w-3/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.senderAddress') }}</p>
            <p class="ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto">{{ data.pickup_address }}</p>
          </div>
        </div>
        <div class="mt-4 p-2 bg-neutral-200 rounded-md">
          <p class="text-sm font-medium mb-1 text-neutral-700">Detail Pickup</p>
          <p>{{ data.pickup_detail || '-' }}</p>
        </div>
      </div>
      <div class="w-2/5 border-r p-4 mdmax:border-none mdmax:p-4 mdmax:w-full mdmax:shadow-border-b">
        <div class="flex justify-between items-start gap-6 mdmax:gap-2">
          <div class="w-2/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700 whitespace-nowrap">{{ $t('order.orderCard.receiverName') }}</p>
            <p class="font-medium mb-1 leading-5 max-h-10 h-10 overflow-y-hidden" :title="data.receiver_name">{{ data.receiver_name }}</p>
            <p class="text-neutral-400 text-sm">{{ data.receiver_phoneno }}</p>
          </div>
          <div class="w-3/5 mdmax:w-1/2">
            <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.receiverAddress') }}</p>
            <p class="ellipsis overflow-hidden mdmax:h-auto mdmax:overflow-auto">{{ data.destination_address }}</p>
          </div>
        </div>
        <div class="mt-4 p-2 bg-neutral-200 rounded-md">
          <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.detailShipping') }}</p>
          <p>{{ data.destination_detail || '-' }}</p>
        </div>
      </div>
      <div class="w-1/5 p-4 mdmax:w-full mdmax:shadow-border-b">
        <div class="mb-6">
          <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.weight') }}</p>
          <p>{{ data.goods_weight }} kg</p>
        </div>
        <div class="">
          <p class="text-sm font-medium mb-1 text-neutral-700">{{ $t('order.orderCard.goodsCategory') }}</p>
          <p>{{ data.goods_category }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  components: {
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    Chevron: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Chevron'),
    LogisticPlaceholder: () => import(/* webpackChunkName: "LogisticPlaceholder" */ '@/components/Icons/LogisticPlaceholder')
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visibleContent: false,
      status: {
        PYMWAI: 'text-neutral-500 bg-neutral-300',
        PYMCNF: 'text-white bg-system-warning',
        DLVD: 'text-white bg-system-success',
        CNC: 'text-white bg-system-error',
        HUBPRCD: 'text-white bg-system-warning',
        HUBRJCT: 'text-white bg-system-error',
        OCNCL: 'text-white bg-red-500',
      }
    }
  },
  methods: {
    goToDetail(id) {
      this.$router.push(`/order/detail/${id}`)
    },
    expand() {
      this.visibleContent = !this.visibleContent
    }
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    statusClass() {
      return this.status[this.data.status]
    }
  }
}
</script>
<style lang="scss" scoped>
.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.25;
  height: 60px;
  word-break: break-all;
}
</style>
